import {Base64} from 'js-base64';
import {createAction} from 'redux-actions';
import ConfigTypes from '~/constants/types/ConfigTypes';
import {
  getAnchorStyle,
  isSleeveDecoEligibleStyle
} from '~/selectors/ProductSelectors';
import {hasSleeveDesign} from '~/selectors/CanvasSelectors';
import {isInternalUser} from '~/selectors/AccountSelectors';
import {enableSleevePrint} from '~/actions/CanvasActions';
import {attemptFireNoSleeveImagesTag} from '~/actions/AnalyticsActions';

import MediaQueries, {breakpoint} from '~/constants/MediaQueries';

export function setCartMode(modeBoolValue) {
  return dispatch => {
    dispatch({
      type: ConfigTypes.UPDATE_CART_MODE,
      payload: modeBoolValue
    });
  };
}

export const setClipartRecoloring = createAction(
  ConfigTypes.SET_CLIPART_RECOLORING
);

export const setSleevePrintOverride = createAction(
  ConfigTypes.SET_SLEEVE_PRINT_OVERRIDE
);

export const updateLastSaved = createAction(ConfigTypes.UPDATE_LAST_SAVED);

export function updateLabExitWarningEligibility(eligible) {
  return dispatch => {
    dispatch({
      type: ConfigTypes.UPDATE_LAB_EXIT_WARNING_ELIGIBILITY,
      payload: eligible
    });
  };
}

export function loadCartCookie({
  token = '',
  postal_code = '',
  order_item_count = 0
} = {}) {
  return dispatch => {
    dispatch({
      type: ConfigTypes.UPDATE_CART_COOKIE,
      payload: {
        email: Base64.decode(token),
        postalCode: postal_code,
        orderItemCount: order_item_count
      }
    });
  };
}

export function setStreamlinedMobileMode(modeBoolValue) {
  return dispatch => {
    dispatch({
      type: ConfigTypes.UPDATE_STREAMLINED_MOBILE_MODE,
      payload: modeBoolValue
    });
  };
}

export function setStreamlinedMobileIntent(intent) {
  return dispatch => {
    dispatch({
      type: ConfigTypes.UPDATE_STREAMLINED_MOBILE_INTENT,
      payload: intent
    });
  };
}

export const updateSleevePrintOverride = () => (dispatch, getState) => {
  const state = getState();
  const anchorStyle = getAnchorStyle(state);
  const hasSleeveView = !!anchorStyle?.views?.find(view =>
    view?.name?.includes('Sleeve')
  );
  const isSleeveDecoEligible = isSleeveDecoEligibleStyle(state)(
    anchorStyle?.id
  );
  const isMobile = breakpoint(MediaQueries.mediumAndBelow);

  if (!hasSleeveView) {
    dispatch(setSleevePrintOverride(false));
    return false;
  }

  if (
    hasSleeveDesign(state) ||
    (isInternalUser(state) && isSleeveDecoEligible)
  ) {
    dispatch(setSleevePrintOverride(true));
    dispatch(enableSleevePrint(true));
    dispatch(attemptFireNoSleeveImagesTag());
    return true;
  }

  if (!isMobile && isSleeveDecoEligible) {
    dispatch(setSleevePrintOverride(true));
    dispatch(attemptFireNoSleeveImagesTag());
    return true;
  }

  if (isMobile || !isSleeveDecoEligible) {
    dispatch(setSleevePrintOverride(false));
    dispatch(enableSleevePrint(false));
  }

  return false;
};
